const iframeTemplate = (iframe: string) => `<div class="iframeWrap">${iframe}</div>`;

export const iframeRender = (text: string) =>
  text.replace(/(<iframe.*?>[\w\W]*?<\/iframe>)/g, iframeTemplate);
